import Big from "big.js";
import { defaultMaxJobValue } from "./constants";

// Booking form placeholder text
export const placeHold_book_name_default = "Item name e.g. sofa, bed etc";
export const placeHold_book_desc_multipleitems =
  "Help our MAVs to quote: \nWhat Floor? Have a lift? \nHandle with care? \nAnything heavy? \n- Or any useful info";
export const placeHold_book_desc_wastedisposal =
  "Help our MAVs to quote: \nWhat Floor? Have a lift? \nAnything hazardous? \n- Or any useful info";
export const placeHold_book_desc_removals =
  "Help our MAVs to quote: \nWhat Floor? Have a lift? \nHandle with care? \nIs it heavy? \n- Or any useful info";
export const placeHold_book_desc_houseclearance =
  "Help our MAVs to quote: \nWhat Floor? Have a lift? \nAnything hazardous? \nAnything heavy? \n- Or any useful info";
export const placeHold_book_desc_default =
  "Help our MAVs to quote: \nWhat Floor? Have a lift? \nHandle with care? \nAnything heavy? \n- Or any useful info";
export const placeHold_book_address = "Postcode or address";
export const placeHold_address_from = "Address of pick up";
export const placeHold_address_to = "Address where to take the items";
export const placeHold_address_selected = "Postcode or address";

// System / session messages
export const sessionExpired = "Please sign in again to continue.";
export const appVersionOutdatedExpired =
  "This version of Man+Van is outdated, please update and try again.";
export const userIsBlocked =
  "Unfortunately your account has been blocked. Please contact support if you believe this to be in error.";
export const serverTimeOutMsg =
  "Unfortunately the server could not be contacted, please try again later or contact support.";

// Admin — job messages
export const adminResumeJob = "Are you sure you want to resume this job?";
export const adminPauseJob = "Are you sure you want to pause this job?";
export const adminResumeNotice = "Upon saving the job will become open to quotes.";
export const adminPauseNotice =
  "Upon saving the customer will receive notice and the job will be temporarily closed to quotes.";
export const adminSaveChangesConfirm = "Are you sure you want to save these changes?";
export const adminReassignConfirm = "Are you sure you want to reassign this job?";
export const adminJobAlreadyClosed = "The job is closed so can not be modified.";
export const adminJobAlreadyPaidStatus =
  "The job is already agreed and paid, it can only be set as paid, complete or closed.";
export const adminJobAlreadyComplete =
  "The job is already complete so can not be modified.";
export const adminQuoteArchived = "";
export const adminJobAlreadyRefunded = "The refunded is complete so cannot be reversed.";
export const adminJobAlreadyPaidSetClosedNotice =
  "The job is already agreed and paid, upon saving the job as closed, the customer will be refunded.";
export const adminJobAlreadyPaidSetCompleteNotice =
  "The job is already agreed and paid, upon saving the job as complete the MAV will be paid.";
export const adminJobReassignmentNotice =
  "The job (and the successful quote) will be transferred to the selected MAV upon saving.";
export const adminJobRefundApprovedNotice =
  "The payment will be refunded and the client will be notified upon saving.";
export const adminJobAlreadyPaid =
  "The job is already agreed and paid so can not be modified.";
export const adminJobOpenOther = "An open job can only be set as open or closed.";
export const adminJobClosed = "This job is closed and can not be reopened.";

// Admin — quote messages
export const adminQuoteAlreadyPaidSetAny =
  "The quote is already agreed and paid, it can only be marked as completed or closed via it's job.";
export const adminQuoteAlreadyPaidPrice =
  "The quote is already agreed and paid, it's price can not be changed.";
export const adminQuoteOpenOther = "An open quote can only be set as open or closed.";
export const adminQuoteClosed = "A closed quote can only be set as open or closed.";

// Admin — client/mav messages
export const adminClientCannotPreactivate =
  "A client can not be manually set to 'pending' as this is this is part of the activation process.";
export const adminClientCannotReset =
  "A client can not be manually set to 'resetting', as only the client can do this via the 'forgot password' screens.";
export const adminMavCannotPreactivate =
  "A MAV can not be manually set to 'pending' as this is this is part of the activation process.";
export const adminMavCannotReset =
  "A MAV can not be manually set to 'resetting', as only the MAV can do this via the 'forgot password' screens.";
export const adminMavWillCreateStripe =
  "As the MAV doesn't yet have a linked Stripe account, one will be created upon saving changes and the MAV will be contacted by Stripe for bank details etc.";

// Registration validation messages
export const registerAvatarImage =
  "All drivers are required to have a profile picture. This gives customers confidence in using you and increases conversions. Please upload a photo. ";
export const registerAvatarWarning =
  "Please note we are unable to display images that include business names, telephone numbers etc";
export const registerNameValidation = "Please enter a valid name (3-20 characters).";
export const registerEmailValidation = "Please enter a valid email.";
export const registerTelemailValidation =
  "Please enter a valid telephone number or email address.";
export const registerConfirmEmailValidation = "Please check the email addresses match.";
export const registerTelephoneValidation = "Please enter a valid telephone.";
export const registerUsernameValidation =
  "Please enter a valid username (3-20 characters).";
export const registerDrivingLicenceValidation =
  "Please enter a valid driving licence number.";
export const registerCompanyNameValidation =
  "Please enter a valid company name (optional).";
export const registerVatNumberValidation = "Please enter a valid VAT number (optional).";
export const registerWasteHandlingLicenceValidation =
  "Please enter a valid waste handling licence number (optional).";
export const registerPasswordValidation =
  "Please enter a valid password (6-20 characters).";
export const registerPublicLiabilityInsuranceValidation =
  "Public liability insurance is required to register (documentation will need to be supplied upon request).";
export const registerGoodsInTransitInsuranceValidation =
  "Goods in transit insurance is required to register (documentation will need to be supplied upon request).";
export const registerGeneralVanInsuranceValidation =
  "General van insurance is required to register (documentation will need to be supplied upon request).";
export const registerTermsValidation =
  "Please agree to the terms & conditions to register.";

// Payment validation messages
export const paymentCardValidation = "Please enter a valid card number.";
export const paymentCvcValidation = "Please enter a valid cvc number.";
export const paymentExpMonth = "Please select an expiry month.";
export const paymentExpYear = "Please select an expiry year.";

// Quote decline
export const quoteDeclineHeading = "Are you sure?";
export const quoteDeclineMessage =
  "Please let us know why so we can continue to improve our service:";

// Booking v2 UI labels
export const bookV2ServiceType = "I would like to";
export const bookV2ServiceTypeSendItems = "Send items to someone";
export const bookV2ServiceTypeGetItems = "Get items brought to me";
export const bookV2ServiceTypeMove = "Move house";
export const bookV2ServiceTypeDispose = "Dispose of something";
export const bookV2Location = "Location ";
export const bookV2DateAndTime = "Date and Time";
export const bookV2Price = "Price";
export const bookV2Summary = "Final step";

export const bookV2ItemDetails_advice =
  "Help our drivers give you better quotes by uploading clear photos and providing as many details as possible.";

export const bookV2ServiceDescription_pholder = `E.g.
- What is the item? (sofa, boxes, etc.)
- Is it fragile?
- Is it difficult-to-carry?
- What floor? Is there a lift?`;

export const bookV2ServiceTypeSendItems_copy =
  "Perfect option if you need to have something picked up from your location and delivered to someone else.";
export const bookV2ServiceTypeGetItems_copy =
  "Right option if you need something to be picked up from somewhere else and have it brought to you (e.g. an Ebay or Facebook purchase).";
export const bookV2HouseMove_copy = "Select this option if you are moving house.";
export const bookV2Dispose_copy =
  "Right option if you have waste to dispose of (e.g. garden waste, builders waste, household rubbish, etc.), need items taken to a tip or a house clearing.";

export const bookV2SingleItem = "Single Item";
export const bookV2MultipleItems = "Multiple Items";
export const bookV2WasteDisposal = "Waste Disposal";
export const bookV2TipRun = "Tip Run";
export const bookV2HouseClearance = "House Clearance";

export const bookV2WasteDisposal_copy =
  "Right option if you have waste to dispose of (e.g. garden waste, builders waste, household rubbish, etc.)";
export const bookV2TipRun_copy =
  "Right option if you need to dispose of household items and have them taken to a tip.";
export const bookV2HouseClearance_copy =
  "Perfect option if you need to clear the contents in a house or flat (including full or part clearance, removal of carpets, etc.)";

export const bookV2DateAndTimeToday_heading = "Today";
export const bookV2DateAndTimeToday_copy =
  "Let our drivers know the time interval for pickup.";
export const bookV2DateAndTimeTomorrow_heading = "Tomorrow";
export const bookV2DateAndTimeTomorrow_copy =
  "Let our drivers know the time interval for pickup.";
export const bookV2DateAndTimeThisweek_heading = "This week";
export const bookV2DateAndTimeThisweek_copy =
  "Let our drivers know what days this week they can come to pick up the item(s).";
export const bookV2DateAndTimeSpecificdate_heading = "On a specific date";
export const bookV2DateAndTimeSpecificdate_copy =
  "Let our drivers know what date and time to come and pick up the item(s).";
export const bookV2DateAndTimeNotsure_heading = "Not sure — I just want a price";
export const bookV2DateAndTimeNotsure_copy =
  "Great option if you just want to find out how much it would cost to move something.";

// Booking v2 validation messages
export const bookV2Validation_serviceType = "Please select a service";
export const bookV2Validation_serviceSubType = "Please tell us more about your job";
export const bookV2Validation_photo = "Please add at least one photo";
export const bookV2Validation_serviceDescription = "Please tell us about the item";
export const bookV2Validation_originAddress =
  "Please enter a valid address to pick up from";
export const bookV2Validation_destinationAddress =
  "Please enter a valid address to deliver to";
export const bookV2Validation_dateAndTime = "Please select a date and time";
export const bookV2Validation_dateAndTime_thisweek =
  "Please select at least one day of this week";

// Booking v2 summary labels
export const bookV2Summary_senditems_singleitem = "Send a Single Item";
export const bookV2Summary_senditems_multipleitems = "Send Multiple Items";
export const bookV2Summary_getitems_singleitem = "Get a Single Item";
export const bookV2Summary_getitems_multipleitems = "Get Multiple Items";
export const bookV2Summary_housemove_ = "House Move";
export const bookV2Summary_housemove_false = "House Move";
export const bookV2Summary_housemove_singleitem = "House Move";
export const bookV2Summary_housemove_multipleitems = "House Move";
export const bookV2Summary_housemove_wastedisposal = "House Move";
export const bookV2Summary_housemove_tiprun = "House Move";
export const bookV2Summary_housemove_houseclearance = "House Move";
export const bookV2Summary_dispose_wastedisposal = "Waste Disposal";
export const bookV2Summary_dispose_tiprun = "Tip Run";
export const bookV2Summary_dispose_houseclearance = "House Clearance";

// Booking validation messages
export const bookAddressElaborateNudge =
  "Please try to give as much information as possible to cut down on questions on the day of the job, your full address won't be revealed to the drivers until it is a confirmed booking";
export const bookNameValidation = "Please enter a valid name (3-40 characters).";
export const bookPriceValidation = "Please enter a valid price.";
export const bookDescValidation = "Please enter a valid description.";
export const bookReviewValidation = "Please enter a valid review.";
export const bookMinImage =
  "Please add at least one image so our drivers can accurately quote your job.";
export const bookAdditionalValidation =
  "Please enter valid additional info (up to 500 characters).";
export const bookFromValidation = "Please enter a valid from address (3-20 characters).";
export const bookToValidation = "Please enter a valid to address (3-20 characters).";
export const bookDateTimeValidation = 'Please select a date and time or "ASAP".';
export const bookWeightValidation = "Please select a weight indication.";
export const bookWeightExtraValidation =
  "Please select weight indication extra details.";
export const bookFromAddNotGoogleValid =
  "The origin address you entered could not be located, this may prevent drivers from finding your job if they are searching by location. Please select an address from the drop-down options to help our drivers find you.";
export const bookToAddNotGoogleValid =
  "The destination address you entered could not be located, this may prevent drivers from finding your job if they are searching by location. Please select an address from the drop-down options to help our drivers find you.";
export const bookBothAddNotGoogleValid =
  "The origin and destination addresses you entered could not be located, this may prevent drivers from finding your job if they are searching by location. Please select a addresses from the drop-down options to help our drivers find you.";
export const bookAddressesSame =
  "The origin and destination addresses you entered are the same, is this correct?";
export const bookEditLoseQuotesWarning =
  "Please note that you will lose any quotes received if you modify the job details. The job will be submitted as a new quote request.";

// Quote validation messages
export const quotePriceValidation =
  "Please enter a valid quote of up to a value of £" +
  Big(defaultMaxJobValue - 1).toFixed(2) +
  " plus MAV commission.";
export const quoteMessageValidation = "Please enter a valid message or leave blank.";
export const quoteDescValidation = "Please enter a valid description.";
export const quoteMenValidation = "Please select a number of men.";
export const quoteVansValidation = "Please select a number of vans.";

// OTP messages
export const otpValidation = "Please enter a valid verification code (6 characters).";
export const otpFail =
  "The verification code you entered is incorrect or has expired, please try again.";
export const otpFailSMS =
  "There was an error sending an SMS to this number, please check it and try again";

// Registration result messages
export const registerFail =
  "Unfortunately there was an error registering you, please try again, or contact support.";
export const registerFailNameExists =
  "That name is already used by another account, please use another";
export const registerFailUserNameExists =
  "That username is already used by another account, please use another";
export const registerFailEmailExists =
  "That email address is already used by another account, please use another";
export const registerFailTelExists =
  "That telephone number is already used by another account, please use another";
export const registerFailName = "Please enter a valid name and try again.";
export const registerFailTel = "Please enter a valid telephone number and try again.";
export const registerFailUsername = "Please enter a valid username and try again.";
export const registerFailDrivingLicence = "Please enter a valid driving licence number.";
export const registerFailEmail = "Please enter a valid email and try again.";
export const registerFailPassword = "Please enter a valid password and try again.";
export const registerFailTerms = "Please agree to the terms & conditions and try again.";
export const registerFailEmailMatch =
  "Please check that email and confirmation email match";
export const registerSuccess_client =
  "You registered successfully, we've sent a verification link to your email address";
export const registerSuccess_mav =
  "You registered successfully, we'll be in touch to confirm a few details so we can get you started";
export const registerVerifyOtp =
  "Please verify your account with the code sent to your telephone number";
export const registerVerifySuccess_client = "Thanks, welcome to your new account";
export const registerVerifySuccess_mav =
  "You registered successfully, we'll be in touch to confirm a few details so we can get you started";
export const profileEditTelVerifyOtp =
  "Please verify your new telephone number with the code sent";

// Terms
export const termsHeading = "Terms & conditions";
export const termsCopy =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus venenatis blandit aliquam. Ut ex nisl, lacinia non pellentesque non, efficitur quis erat. Etiam ullamcorper turpis ut placerat rutrum. Nullam sapien erat, tincidunt quis leo eget, placerat pellentesque mi. Pellentesque sollicitudin ipsum metus, ut mollis lectus placerat at.";

// Sign-in messages
export const signInFail =
  "We couldn't sign you in, please check your details and try again, or contact support.";
export const signInFailPassword =
  "Your password is invalid, please check your details and try again.";
export const signInFailEmail =
  "Your email address is invalid, please check your details and try again.";
export const signInFailTelemail =
  "Your telephone / email address is invalid, please check your details and try again.";
export const signInSuccessVerification =
  "Your email address hasn't been verified yet, you could lose access to your account if your email address is incorrect, resend verification link?";
export const signInFailActivation =
  "We couldn't sign you in as your account hasn't been activated yet, please check your email.";
export const signInFailTooManyAttempts =
  "You have made too many incorrect attempts to sign in, please wait five minutes and try again.";
export const genericFailTooManyAttempts =
  "You have made too many unsuccessful attempts, please wait five minutes and try again.";
export const signInFailTooManyResets =
  "You have made too many reset requests, please wait five minutes and try again.";

// Forgot / reset password messages
export const forgotSuccess = "A reset link was sent to you, please check your email.";
export const forgotFail =
  "Unfortunately there was an error generating a reset link, please try again, or contact support.";
export const forgotFailInvalidEmail =
  "There was no user found with that email address, please check it and try again or contact support.";
export const forgotFailInvalidTel =
  "There was no user found with that telephone number, please check it and try again or contact support.";
export const resetSuccess =
  "Your password was reset successfully, please sign in to continue";
export const resetFail =
  "Unfortunately there was an error setting your password, please try again, or contact support.";
export const resetFailPassword = "The password you entered was invalid.";
export const resetFailCode =
  "Your password could not be reset because your reset code is invalid.";

// Messaging messages
export const mesageToMavWarning =
  "Please note that messaging is monitored and is intended to allow MAVs and clients to arrange bookings and quotes.";
export const mesageFailNoConnection = "Unfortunately you can not contact this user.";
export const mesageFail = "Unfortunately there was an error sending your message.";
export const messageValidation = "Please enter a valid message.";

// Misc user messages
export const takePhotoFail = "Unfortunately there was an error taking a photo.";
export const userEditSuccess = "Your details were successfully udated.";
export const userBaseLocationNotFound =
  "Your base location has not been set, please select a location and range so you can receive location based job alerts.";
export const mavBaseLocationNotFound =
  "Driver location could not be found, please select a location from the drop down list so they can receive location based job alerts (or leave blank).";
export const userEditFail = "Unfortunately there was an error updating your details.";

// Job messages
export const jobNotFound = "Unfortunately that job could not be found.";
export const jobNoLongerAvailable =
  "This job is no longer available, better luck next time!";
export const jobDateInPast = "Please select a time and date in the future.";
export const jobDateTooFarAheadA =
  "Your booking date is too far in the future, please select a date less than ";
export const jobDateTooFarAheadAAlt = "Please select a date less than ";
export const jobDateTooFarAheadB = " days from now.";
export const jobCreateSuccess = "Your job was created successfully.";
export const jobCreateSuccessLong =
  "Thank you for your job post!<br/><br/>You will shortly start to receive quotes from drivers who can do this job for you; simply select the quote that suits you best and confirm your booking by paying a deposit via the app, then pay the driver the balance when the job is done!";
export const jobCreateSuccessV2 =
  "Thank you for your quote request!<br/><br/>You will now start to receive quotes from drivers. Simply pick the cheapest quote and/or best rated driver.";
export const jobCreateSuccessV2_note =
  "Note: You can choose to pay a deposit via the app and the balance to the driver on the day, or pay in full in advance via the app.";
export const jobCreateFail = "Unfortunately there was an error creating your job.";
export const jobSaveSuccess =
  "Your quote request has been updated and is awaiting driver responses.";
export const jobSaveFail = "Unfortunately there was an error saving your job.";
export const jobSaveNoQuotesConfirm = "Are you sure you want to save these changes?";
export const jobSaveHasQuotesConfirm =
  "Please note that you will lose any quotes received if you modify the job details. The job will be submitted as a new quote request.";
export const jobQuoteNoApplicable =
  "This quote is unavailable as it's no longer applicable.";
export const jobLeaveScreenHeading = "Save these changes?";
export const jobLeaveScreenSaveHasQuotes =
  "You have unsaved updates to your booking. Please note that on saving all previous quotes will be automatically removed as they will no longer be applicable.";
export const jobLeaveScreenSaveNoQuotes = "You have unsaved updates to your booking.";
export const jobLeaveScreenToQuoteDiscardConfirm =
  "You have unsaved updates to your booking, leaving this screen will discard the changes, proceed?";
export const bookLeaveScreenHeading = "Discard booking?";
export const bookLeaveScreenConfirm =
  "Leaving this screen will discard your booking, proceed?";
export const bookingLeaveScreenHeading = "Discard changes?";
export const bookingLeaveScreenConfirm =
  "Leaving this screen will discard your changes, proceed?";
export const jobCancelSuccess = "Your job has been successfully cancelled.";
export const jobCancelSuccessWasOpen =
  "Thanks, we've updated our records and removed the job.";
export const jobCancelFail = "Unfortunately there was an error cancelling your job.";
export const jobCancelConfirmGeneric = "Are you sure you would like to cancel this job?";
export const jobCancelConfirmStillOpen = "Are you sure you would like to cancel?";
export const jobCancelConfirmRefund =
  "Are you sure you would like to cancel this job?<br/>Your payment will be automatically refunded.";
export const jobCancelConfirmRefundA =
  "Are you sure you would like to cancel this job?<br/>You will be automatically refunded your payment of £";
export const jobCancelConfirmRefundB = " minus a processing fee of £";
export const jobCancelConfirmRefundC = ".";
export const jobCancelConfirmRefundRequest =
  "Are you sure you would like to cancel this job?<br/>Admin will process your refund and notify you when it's complete.";
export const jobCancelConfirmNoRefund =
  "Are you sure you would like to cancel this job?<br/>Your payment can not be refunded.";
export const jobCompleteSuccess =
  "Your job has been successfully completed, thank you.<br/>Please be sure to review your driver to help us ensure quality of service.";
export const jobCompleteFail = "Unfortunately there was an error completing your job.";
export const jobReviewInvalidStars = "Please select a rating of between 1 and 5 stars.";
export const jobReviewSuccess = "Your job has been successfully reviewed, thank you.";
export const jobReviewFail = "Unfortunately there was an error submitting your review.";

// Quote messages
export const quoteNotFound = "Unfortunately that job could not be found.";
export const quoteNoLongerAvailable = "This quote is no longer available.";
export const quoteNoWasteLicence =
  "This job is only open to drivers with a waste handling licence, if you have one please add it to your profile.";
export const quoteCreateSuccess = "Your quote was created successfully.";
export const quoteCreateFail = "Unfortunately there was an error creating your quote.";
export const quoteCreateFail_comExpired =
  "The commission for this job has changed, please check prices and resubmit.";
export const quoteCancelSuccess = "Your quote has been successfully cancelled.";
export const quoteCancelAfrerDeclinedSuccess =
  "Your quote has been successfully cancelled, you can now create a new quote for this job.";
export const quoteCancelFail = "Unfortunately there was an error cancelling your quote.";
export const quoteDeclineSuccess = "Quote successfully declined.";
export const quoteDeclineFail = "Unfortunately there was an error declining this quote.";
export const quoteCancelConfirmGeneric =
  "Are you sure you would like to cancel this quote?<br>You won't be able to requote on this job.";
export const quoteReviewSuccess = "Your job has been successfully reviewed, thank you.";
export const quoteReviewFail =
  "Unfortunately there was an error submitting your review.";
export const quoteCompleteConfirm =
  "Are you sure you want to mark this job as complete?";
export const quoteCompleteSuccess =
  "Your job has been successfully completed, thank you.";

// Location / coordinate failure messages
export const jobCoordiatesFail_client_notinuk =
  "You must be in the United Kingdom to use this feature.";
export const jobCoordiatesFail_client_mobile =
  "Your location couldn't be found, please check that location services are enabled on your device.";
export const jobCoordiatesFail_client_web =
  "Your location couldn't be found, please check that location services are enabled on your browser.";
export const jobCoordiatesFail_mav_mobile =
  "Your location couldn't be used to find jobs, please check that location services are enabled on your device.";
export const jobCoordiatesFail_mav_web =
  "Your location couldn't be used to find jobs, please check that location services are enabled on your browser.";
export const clientPaymentSuccess =
  "Your payment was successful and your MAV is booked.";
export const clientPaymentFailedGeneric =
  "Unfortunately there was an error making your payment.";
export const clientPaymentFailedMissingDetails =
  "Unfortunately there was an error making your payment, please check card details.";
export const jobLocationFail_client_web = "Your location couldn't be found.";
export const jobLocationFail_mav_mobile = "Your location couldn't be used to find jobs.";

// Dev mode notices
export const devModeNotice_app =
  "Users/jobs/quotes created will appear on the dev admin server.<br/>Payments with Stripe test cards will be viewable via the 'View test data' toggle on the Stripe dashboard.";
export const devModeNotice_admin =
  "Users/jobs/quotes can be created via the development version of the mobile app.<br/>Stripe payment links (ie via a paid job) will automatically show the test data in the Stripe dashboard.";
